export const useDefaultData = ({Helpers}) => {

    const {getCurrentDate} = Helpers

    const defaultFormGlobal = {
        idcotizacion: 0,
        fecha: getCurrentDate(),
        tipo_cuota: '',
        interes: 0,
        descripcion: '',
        nombre_cliente: '',
        monto_venta: 0,
        interes_total: '0 %',
        monto_enganche: 0,
        saldo_financiar: 0,
        enganche: '0 %',
        plazo: 0,
        plazo_anios: 0,
        gps: 0,
        otros: 0,
        seguro: 0,
        cuota_niv: 0,
        total_cuota: 0,
        descripcion: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
        
        clean_monto_venta: 0,
        clean_cuota_niv: 0,
        clean_total_cuota: 0,
        clean_monto_enganche: 0,
        clean_interes: 0,
        clean_plazo: 0,
        clean_gps: 0,
        clean_seguro: 0,
        clean_otros: 0,
        
    }

    const typesLoans = [
        { value: 'CUOTA LIBRE', label: 'CUOTA LIBRE' },
        { value: 'CUOTA NIVELADA', label: 'CUOTA NIVELADA' }
    ];

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    return Object.freeze({
        defaultFormGlobal,
        typesLoans,
        defaultDataModal,       
    })
}